"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealHalalLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealHalalLinear = function MealHalalLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.552 6.064c.958-.345 1.767.78 1.126 1.568a12.294 12.294 0 00-2.765 7.786c0 6.848 5.587 12.399 12.479 12.399 1.47 0 2.902-.252 4.253-.739.958-.345 1.766.781 1.126 1.569a14.499 14.499 0 01-11.279 5.357C13.488 34.004 7 27.557 7 19.604c0-6.109 3.865-11.491 9.552-13.54zm-2.412 3.52l-.132.095a12.374 12.374 0 00-4.995 9.926c0 6.848 5.587 12.4 12.479 12.4 2.452 0 4.787-.708 6.768-1.98l.391-.262-.334.025-.23.013-.231.009-.464.007c-8.004 0-14.492-6.447-14.492-14.4 0-1.847.352-3.642 1.016-5.307l.173-.414.05-.112zm14.507 1.586a.4.4 0 01.163.32l.026 3.624 3.52 1.116a.4.4 0 01-.005.764l-3.494 1.07.026 3.596a.4.4 0 01-.719.245l-2.219-2.92-3.521 1.082a.4.4 0 01-.438-.622l2.16-2.893-2.201-2.912a.4.4 0 01.437-.623l3.594 1.108 2.112-2.87a.4.4 0 01.559-.085z",
    fill: "#95A0B3"
  }));
};

exports.MealHalalLinear = MealHalalLinear;
var _default = MealHalalLinear;
exports.default = _default;